import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import { isAuthenticated } from '../lib/api';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/sobre-nosotros/page'));
const ShopPage = lazy(() => import('../pages/tienda/page'));
const EventsPage = lazy(() => import('../pages/eventos/page'));
const OcasionesPage = lazy(() => import('../pages/ocasiones/page'));
const ContactPage = lazy(() => import('../pages/contacto/page'));
const CategoryPage = lazy(() => import('../pages/categoria/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const ArticlePage = lazy(() => import('../pages/blog/ArticlePage'));
const FaqPage = lazy(() => import('../pages/faq/page'));
const MunicipioPage = lazy(() => import('../pages/municipio/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

// Admin pages
const LoginPage = lazy(() => import('../pages/admin/LoginPage'));
const AdminPage = lazy(() => import('../pages/admin/AdminPage'));
const CategoryEditorPage = lazy(() => import('../pages/admin/CategoryEditorPage'));
const OcasionesAdminPage = lazy(() => import('../pages/admin/OcasionesAdminPage'));
const OcasionEditorPage = lazy(() => import('../pages/admin/OcasionEditorPage'));
const PromoAdminPage = lazy(() => import('../pages/admin/PromoAdminPage'));

// Lightweight guard — token presence check; API calls handle expiry (401 → logout)
const ProtectedRoute = ({ children }: { children: React.ReactNode }) =>
  isAuthenticated() ? <>{children}</> : <Navigate to="/admin" replace />;

const routes: RouteObject[] = [
  { path: '/',                  element: <HomePage /> },
  { path: '/categoria/:slug',   element: <CategoryPage /> },
  { path: '/sobre-nosotros',    element: <AboutPage /> },
  { path: '/tienda',            element: <ShopPage /> },
  { path: '/eventos',           element: <EventsPage /> },
  { path: '/ocasiones',         element: <OcasionesPage /> },
  { path: '/contacto',          element: <ContactPage /> },
  { path: '/blog',              element: <BlogPage /> },
  { path: '/blog/:slug',        element: <ArticlePage /> },
  { path: '/faq',               element: <FaqPage /> },
  { path: '/municipio/:slug',   element: <MunicipioPage /> },
  // Admin
  { path: '/admin', element: <LoginPage /> },
  {
    path: '/admin/categorias',
    element: <ProtectedRoute><AdminPage /></ProtectedRoute>,
  },
  {
    path: '/admin/categorias/:slug',
    element: <ProtectedRoute><CategoryEditorPage /></ProtectedRoute>,
  },
  {
    path: '/admin/ocasiones',
    element: <ProtectedRoute><OcasionesAdminPage /></ProtectedRoute>,
  },
  {
    path: '/admin/ocasiones/:slug',
    element: <ProtectedRoute><OcasionEditorPage /></ProtectedRoute>,
  },
  {
    path: '/admin/promo',
    element: <ProtectedRoute><PromoAdminPage /></ProtectedRoute>,
  },
  { path: '*', element: <NotFound /> },
];

export default routes;
